import { BaseFetch } from "../main-model"
export default class ActivityModel extends BaseFetch {
  getActivityBy = (data) =>
    this.authFetch({
      url: "activity/getActivityBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getActivityById = (data) =>
    this.authFetch({
      url: "activity/getActivityById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateActivityById = (data) =>
    this.authFetch({
      url: "activity/updateActivityById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertActivity = (data) =>
    this.authFetch({
      url: "activity/insertActivity",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteActivityById = (data) =>
    this.authFetch({
      url: "activity/deleteActivityById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
